<template>
  <div class="d-none">
    <b-modal
      v-model="showModal"
      centered
      header-class="custom-modal-header"
      footer-class="custom-modal-footer"
    >
      <template #modal-header>
        <p class="text-header">Import File</p>
      </template>
      <b-row>
        <b-col>
          <UploadFile
            textFloat="Import File"
            placeholder="Please Choose File"
            format="excel"
            name="file"
            text="*Please upload only file .xlsx less than 10 MB"
            isRequired
            v-on:onFileChange="onFileChange"
            v-on:delete="deleteFile"
            :fileName="filename"
            id="uploadfile"
            v-model="form.File"
          />
        </b-col>
      </b-row>
      <template #modal-footer>
        <div class="w-100 d-flex justify-content-between">
          <button class="cancel-button" @click="hide">Cancel</button>
          <button class="save-button" @click="uploadFile">Confirm</button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import UploadFile from "@/components/inputs/UploadFile";

export default {
  props: {
    base64: {
      required: false,
      type: Boolean,
    },
  },
  components: {
    UploadFile,
  },
  data() {
    return {
      showModal: false,
      filename: "",
      form: {
        File: "",
      },
      isDisable: false,
      modalMessage: "",
    };
  },
  methods: {
    show() {
      this.deleteFile();
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
    },
    deleteFile() {
      this.form.File = null;
      this.filename = null;
      this.isDisable = true;
    },
    onFileChange(file) {
      let data = null;
      this.filename = file.name;
      this.form.file_name = file.name;
      this.isDisable = false;
      // const str =
      //   "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,";
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        data = this.base64
          ? `doc;${reader.result.split("sheet;")[1]}`
          : reader.result;
        // this.form.File = reader.result.substring( str.length, reader.result.length );
        this.form.File = data;
      };
    },
    async uploadFile() {
      this.$emit("uploadFile", this.form);
    },
  },
};
</script>

<style scoped>
.modal-header {
  border-bottom: 0 !important;
  margin: 0px;
  padding: 0px;
  padding-bottom: 0.25rem;
}
.text-msg {
  font-size: 2rem;
  color: #4a4a4a;
}
.text-text {
  color: #4a4a4a;
  margin-bottom: 0;
  font-size: 1.2rem;
}
.text-sub {
  color: #afce38;
  font-size: 1.25rem;
}
.modal-body {
  margin: auto;
  text-align: center;
  padding: 0;
}
.btn-modal {
  width: 100px;
  font-weight: bold;
}
::v-deep .btn-main-1 {
  background-color: #832abf !important;
  border-color: #832abf;
  color: #fff;
}
</style>
